import React, { useState, useEffect } from 'react'
import ModalActionButton from '../../elements/ModalActionButton';
import PlusIcon from '../../elements/icons/PlusIcon';
import AutocompleteSelect from '../../elements/form/AutocompleteSelect';
import Loader from '../../elements/Loader';
import { useSelector, useDispatch } from 'react-redux';
import { fetchRoles } from '../../../store/actions/rolesPermissionsActions';
import axios from 'axios';
import { authHeader, baseUrl } from '../../../utils';
import { SET_SUCCESS } from '../../../store/types';

const UpdateUserRoles = ({staff, currentRoles, reload, close}) => {
    const [roles, setRoles] = useState(currentRoles || []);
    const [addingNewRole, setAddingNewRole] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [selectedRoles, setSelectedRoles] = useState([]);

    const staffSelector = useSelector(state => state.staff);
    const rolesSelector = useSelector(state => state.roles);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchRoles('', 0, 0))

    }, [dispatch]);

    const validateForm = () => {
        const errors = {};
        selectedRoles.forEach((role, index) => {
            if (!role) {
                errors[`role-${index}`] = 'Role is required';
            }
        });
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const updateStaffRoles = async () => {
        if (!validateForm()) {
            return;
        }
        
        const payload = {
            adminRoles: [
                ...roles.map(role => role._id),
                ...selectedRoles]
        };

        const headers = authHeader()
        console.log(payload)
        await axios.patch(`${baseUrl}/user/profile/${staff?.userProfile?._id || staff?.userProfile}`, payload, { headers })
        dispatch({
            type: SET_SUCCESS,
            payload: "Staff roles updated successfully"
        })
        reload()
        close()
    };

    return (
        <div className="w-full">
            {rolesSelector.loadingRoles ? 
                <Loader />
            : 
                <>
                    {roles.length > 0 ? (
                        <div className="mt-4 mb-4">
                            <p className="text-gray-500 text-sm">Current roles for {staff?.name || 'this staff member'}:</p>
                            {roles.map((role, index) => (
                                <div className="w-full rounded-lg p-3 transition duration-400 bg-gray-100 flex items-center justify-between my-3">
                                    <p key={index} className="text-gray-800 text-sm font-space-grotesk font-semibold">{role.name}</p>

                                    <button
                                        type="button"
                                        className="text-gray-500 text-xs hover:bg-gray-200 p-2 rounded-lg font-space-grotesk font-semibold transition duration-200"
                                        onClick={() => {
                                            const updatedRoles = [...roles];
                                            updatedRoles.splice(index, 1);
                                            setRoles(updatedRoles);
                                        }}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-gray-500 text-xs">No roles assigned to {staff?.name || 'this staff member'} yet. Click on "Add new role" below to add new roles.</p>
                    )}

                    {addingNewRole && <>
                        {selectedRoles?.map((role, index) => (
                            <div className="mb-2 flex items-end gap-x-1 pr-3" key={index}>
                                <AutocompleteSelect 
                                    selectOptions={rolesSelector?.roles?.roles?.filter(
                                        (option) => !roles.some((role) => role._id === option._id)
                                    )}
                                    inputLabel="Select New Role"
                                    titleField="name"
                                    displayImage={false}
                                    imageField=""
                                    preSelected={role}
                                    fieldId="employee-role"
                                    requiredField={true}
                                    placeholderText="Select a new role"
                                    hasError={validationErrors[`role-${index}`]}
                                    // return id of accounts of the selected option
                                    returnFieldValue={(value) => {
                                        const updatedRoles = [...selectedRoles];
                                        updatedRoles[index] = value._id;
                                        setSelectedRoles(updatedRoles);
                                    }}
                                />
                                <button
                                    type="button"
                                    className="text-gray-500 text-xs hover:bg-gray-200 p-2 rounded-lg mb-2 font-space-grotesk font-semibold transition duration-200"
                                    onClick={() => {
                                        const updatedRoles = [...selectedRoles];
                                        updatedRoles.splice(index, 1);
                                        setSelectedRoles(updatedRoles);
                                    }}
                                >
                                    Remove
                                </button>
                        </div>
                        ))}
                    </>}

                    <button onClick={() => {
                            setSelectedRoles([...selectedRoles, '']);
                            setAddingNewRole(true)
                        }} className="w-full rounded-lg p-3 transition duration-200 hover:bg-gray-50  text-center flex items-center justify-center text-sm border border-dashed border-gray-300 hover:border-gray-600 mt-4 font-space-grotesk font-semibold">
                        <PlusIcon className={`w-4 h-4`} />
                        Add new role
                    </button>
                </>
            }

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update Roles for ${staff?.name || 'Staff'}`}
                    buttonAction={updateStaffRoles}
                    processing={staffSelector.updatingStaff}
                    disabled={rolesSelector.loadingRoles}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent transition duration-200 hover:bg-opacity-5 rounded-xl hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
            
            </div>
        </div>
    )
}

export default UpdateUserRoles